"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BenefitsIconsWithTitles;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _IconText = _interopRequireDefault(require("../../IconText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function BenefitsIconsWithTitles(_ref) {
  var benefits = _ref.benefits,
    testCase = _ref.testCase;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-details-".concat(testCase, "-icons-list")
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ListGroup, null, benefits.length > 0 && benefits.map(function (benefit, index) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ListItem, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: index === 0 ? 0 : 5
      }
    }, /*#__PURE__*/_react.default.createElement(_IconText.default, {
      size: 5,
      group: "system",
      name: benefit['icon'],
      text: benefit['title']
    })));
  })));
}
BenefitsIconsWithTitles.propTypes = {
  benefits: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    title: _propTypes.default.string
  })),
  testCase: _propTypes.default.string
};